import BaseService from "./BaseService";

class AuthService {
  static async login(data) {
    return await BaseService.callAPI("/sign-in", "POST", data);
  }

  static async forgotPassword(data) {
    return await BaseService.callAPI("/forgot-password", "POST", data);
  }

  static async resetPassword(data) {
    return await BaseService.callAPI("/reset-password", "POST", data);
  }

  static async logout(data) {
    return await BaseService.callAPI("/self/logout", "POST", data);
  }

  static async requestOtp(data) {
    return await BaseService.callAPI("/sign-in/otp", "POST", data);
  }

  static async resendOtp(data) {
    return await BaseService.callAPI("/resend/otp", "POST", data);
  }

  static async verifyOtp(data) {
    return await BaseService.callAPI("/verify/otp", "POST", data);
  }

  // The emergency address and the company sign-in code exchange are anonymous:
  // no stored token goes with them.
  static async emergencySignIn(data) {
    return await BaseService.callAPI("/emergency-sign-in", "POST", data, {}, {}, true);
  }

  static async ssoHandoff(data) {
    return await BaseService.callAPI("/sso/handoff", "POST", data, {}, {}, true);
  }

  // The MFA step sends the half-signed-in token kept as the session's access token.
  static async mfaEnrol() {
    return await BaseService.callAPI("/mfa/enrol", "POST", {});
  }

  static async mfaConfirm(data) {
    return await BaseService.callAPI("/mfa/confirm", "POST", data);
  }

  static async mfaVerify(data) {
    return await BaseService.callAPI("/mfa/verify", "POST", data);
  }

  static async refreshToken(data) {
    return await BaseService.callAPI("/refresh-session", "POST", null, null, {
      Authorization: `Bearer ${data.refreshToken}`,
    });
  }
}

export default AuthService;
